import React, { useState, useEffect, useMemo } from "react";
import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

function About() {
  const [revealedMessages, setRevealedMessages] = useState([]);

  const messages = useMemo(() => [
    "You can go, really.",
    "Please go",
    "I am not hiding anything",
    "Even if I did, I wouldn't tell you",
    "...",
    "Okeeyyy well I am hiding something",
    "BUT I AM NOT GOING TO TELL YOU",
    "...",
    "Oh you're still here?",
    "Today I ate a raw potatoe",
    "It was good! Uh I meant ew...",
    "Okey that was a lie",
    "The potatoe was a lie",
    "Oh uh and the fact that I am hiding something, this was a lie too yeah!!",
    "...",
    "Don't check the source code I swear it's a mess",
    "You did? Well I told you :)"
  ], []);

  useEffect(() => {
    let index = 0; // Start at the first message

    const interval = setInterval(() => {
      if (index < messages.length) {
        setRevealedMessages((prevMessages) => [...prevMessages, messages[index]]);
        index++; // Move to the next message
      } else {
        clearInterval(interval); // Stop when all messages are displayed
      }
    }, 8000); // Every 8 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [messages]);

  return (
    <Layout>
      <Helmet>
        <title>About | Croquette</title>
      </Helmet>
      <h1 className="text-4xl font-bold text-blue-600 mb-5">About This Page</h1>

      <div className="text-lg flex flex-col items-center space-y-2">
        <p>Nothing to see here...</p>
        {revealedMessages.map((msg, i) => (
          <p key={i}>{msg}</p>
        ))}
      </div>
    </Layout>
  );
}

export default About;
